export interface FeatureAccessSnapshot {
  enabled: Record<string, boolean>;
  capabilities?: Record<string, boolean>;
}

export function featureEnabled(
  snapshot: FeatureAccessSnapshot | undefined,
  key: string,
): boolean {
  return snapshot?.enabled[key] === true;
}

export function capabilityEnabled(
  snapshot: FeatureAccessSnapshot | undefined,
  key: string,
): boolean {
  return snapshot?.capabilities?.[key] !== false;
}
